var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _polygon, _path5, _path6, _rect3, _polygon2, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _rect4, _rect5, _polygon3, _path13, _path14, _rect6, _polygon4, _path15, _path16, _circle2, _ellipse;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHammers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 573.08 542.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2b6eae;}.b{fill:#1df3ce;}.c{fill:#fff;}.d{fill:#5badff;}.e{fill:#072441;}.f{fill:#636262;opacity:0.1;isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hammers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3105.53,2059.37s8.71-27.38,49.37-68c73.37-73.37,169-149.2,169-149.2l9.19,9.19s-75.83,95.63-149.2,169c-40.66,40.66-68.62,49.85-68.62,49.85Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3392.49,1791.93s0.43,19.37-15.91,35.71-35.71,15.91-35.71,15.91l-9.19-9.19s-0.43-19.37,15.91-35.71,35.71-15.91,35.71-15.91Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3343,1845.67a5.5,5.5,0,0,1,0,7.78h0a5.5,5.5,0,0,1-7.78,0l-12.73-12.73a5.5,5.5,0,0,1,0-7.78h0a5.5,5.5,0,0,1,7.78,0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3409.46,1793.35a5.5,5.5,0,0,1,0,7.78h0a5.5,5.5,0,0,1-7.78,0l-26.87-26.87a5.5,5.5,0,0,1,0-7.78h0a5.5,5.5,0,0,1,7.78,0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3380.29,
    y: 1692.43,
    width: 105,
    height: 100,
    transform: "translate(-3204.12 1313) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 3301.8,
    y: 1660.95,
    width: 105,
    height: 6,
    transform: "translate(-3171.6 1234.54) rotate(-45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "457.44 44.93 383.2 119.18 374 114.23 452.49 35.74 457.44 44.93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3380.11,1710.26l-29,29a34.36,34.36,0,0,0-7.78-12l27.58-27.58,19.09-19.09,27.58-27.58a34.35,34.35,0,0,0,12,7.78l-29,29",
    transform: "translate(-2977.47 -1624.67)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3416.88,1629.65a17,17,0,0,1,0,24l-74.25,74.25a17,17,0,0,1-24,0h0a17,17,0,0,1,0-24l74.25-74.25a17,17,0,0,1,24,0h0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 3458.78,
    y: 1817.92,
    width: 105,
    height: 6,
    transform: "translate(-3236.63 1391.51) rotate(-45)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "528.15 115.64 453.91 189.89 458.86 199.08 537.35 120.59 528.15 115.64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3465,1795.11l-29,29s5.66,1.41,12,7.78l27.58-27.58,19.09-19.09,27.58-27.58c-6.36-6.36-7.78-12-7.78-12l-29,29",
    transform: "translate(-2977.47 -1624.67)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3545.57,1758.34a17,17,0,0,0-24,0l-74.25,74.25a17,17,0,0,0,0,24h0a17,17,0,0,0,24,0l74.25-74.25a17,17,0,0,0,0-24h0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3101.03,
    cy: 2073.22,
    r: 14.56,
    transform: "translate(-3535.19 1175.32) rotate(-45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3422.5,2059.37s-8.71-27.38-49.37-68c-73.37-73.37-169-149.2-169-149.2l-9.19,9.19s75.83,95.63,149.2,169c40.66,40.66,68.62,49.85,68.62,49.85Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3135.54,1791.93s-0.43,19.37,15.91,35.71,35.71,15.91,35.71,15.91l9.19-9.19s0.43-19.37-15.91-35.71-35.71-15.91-35.71-15.91Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3185,1845.67a5.5,5.5,0,0,0,0,7.78h0a5.5,5.5,0,0,0,7.78,0l12.73-12.73a5.5,5.5,0,0,0,0-7.78h0a5.5,5.5,0,0,0-7.78,0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3118.57,1793.35a5.5,5.5,0,0,0,0,7.78h0a5.5,5.5,0,0,0,7.78,0l26.87-26.87a5.5,5.5,0,0,0,0-7.78h0a5.5,5.5,0,0,0-7.78,0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3045.23,
    y: 1689.93,
    width: 100,
    height: 105,
    transform: "translate(-3302.98 1074.35) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 3170.72,
    y: 1611.45,
    width: 6,
    height: 105,
    transform: "translate(-3224.49 1106.85) rotate(-45)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "115.64 44.93 189.89 119.18 199.08 114.23 120.59 35.74 115.64 44.93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3147.91,1710.26l29,29a34.36,34.36,0,0,1,7.78-12l-27.58-27.58L3138,1680.56,3110.43,1653a34.35,34.35,0,0,1-12,7.78l29,29",
    transform: "translate(-2977.47 -1624.67)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3111.14,1629.65a17,17,0,0,0,0,24l74.25,74.25a17,17,0,0,0,24,0h0a17,17,0,0,0,0-24l-74.25-74.25a17,17,0,0,0-24,0h0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 3013.74,
    y: 1768.42,
    width: 6,
    height: 105,
    transform: "translate(-3381.47 1041.82) rotate(-45)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "44.93 115.64 119.18 189.89 114.23 199.08 35.74 120.59 44.93 115.64"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3063.06,1795.11l29,29s-5.66,1.41-12,7.78l-27.58-27.58-19.09-19.09-27.58-27.58c6.36-6.36,7.78-12,7.78-12l29,29",
    transform: "translate(-2977.47 -1624.67)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2982.45,1758.34a17,17,0,0,1,24,0l74.25,74.25a17,17,0,0,1,0,24h0a17,17,0,0,1-24,0l-74.25-74.25a17,17,0,0,1,0-24h0Z",
    transform: "translate(-2977.47 -1624.67)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3426.99,
    cy: 2073.22,
    r: 14.56,
    transform: "translate(-3439.71 1405.81) rotate(-45)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 286.54,
    cy: 522.3,
    rx: 114.4,
    ry: 20.19
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammers);
export default __webpack_public_path__ + "static/media/hammers.8d6ba8bfc135c9208fa84a14df4020f5.svg";
export { ForwardRef as ReactComponent };